import { getAuth, signOut } from "firebase/auth";
import { secureFetch } from '../data/secureFetch';

const logout = async (toast, navigate) => {
    const auth = getAuth();
    try {
        // Get the current user's UID from Firebase
        const user = auth.currentUser;
        const uid = user ? user.uid : null;

        // Sign out from Firebase
        await signOut(auth);

        // Call backend to revoke refresh tokens and clear cookies
        const response = await secureFetch(`/api/auth/logout`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { uid }, // Send UID for token revocation
        });


        if (!response.ok) {
            throw new Error('Failed to log out from the server');
        }

        // Show success toast and redirect to login page
        toast({
            title: "Logout Successful",
            description: "You have successfully logged out.",
            status: "success",
            duration: 5000,
            isClosable: true,
        });

        navigate('/login');
    } catch (error) {
        // Show error toast
        toast({
            title: "Logout Error",
            description: error.message,
            status: "error",
            duration: 5000,
            isClosable: true,
        });
        console.error('Logout Error:', error);
    }
};

export default logout;
